<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Cadastro de Corporação</strong>
        </div>
        <b-form @submit.stop.prevent>
        <b-form-group label="Nome" label-for="name">
          <b-form-input id="name" type="text" autocomplete="name" v-model="corporation.name"></b-form-input>
        </b-form-group>

        <b-form-group label="CNPJ" label-for="cnpj">
          <b-form-input id="cnpj" type="text" autocomplete="cnpj" v-model="corporation.cnpj"></b-form-input>
        </b-form-group>
        
        <b-form-group label="Administradores">
          <b-col sm="12" lg="2" class="p-0">
            <b-button class="form-control" variant="success" size="sm" v-b-modal.modal-add-admin>Adicionar</b-button>
          </b-col>
          <br>
          <b-row>
            <b-col sm="12" lg="3" v-for="(itm, idx) in corporation.adminUsers" v-bind:key="itm">
              <b-card class="text-center card-list">
                <b-card-text class="">
                  {{itm}}
                </b-card-text>
                <b-row>
                  <b-col sm="12" lg="12" class="p-1">
                    <b-button class="form-control" href="#" variant="danger" size="sm" @click="removeAdmin(idx)">Remover</b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <b-modal
              id="modal-add-admin"
              ref="modal"
              title="Adicionar Administrador"
              @show="resetAdminModal"
              @hidden="resetAdminModal"
              @ok="handleOkAdmin"
            >
            <form ref="form" @submit.stop.prevent="handleSubmitAdmin">
              <b-form-group label="CPF/CNPJ" label-for="admin-username">
                <b-form-input id="admin-username" v-model="adminUser"></b-form-input>
              </b-form-group>
            </form>
          </b-modal>
        </b-form-group>
        
        <b-form-group label="Aplicações">
          <b-col sm="12" lg="2" class="p-0">
            <b-button class="form-control" variant="success" size="sm" v-b-modal.modal-add-app>Adicionar</b-button>
          </b-col>
          <br>
          <b-row>
            <b-col sm="12" lg="3" v-for="(itm, idx) in applications" v-bind:key="itm.clientId">
              <b-card class="text-center card-list">
                <b-card-text class="">
                  <span class="clientID">{{itm.clientId}}</span><br>
                  <strong>{{itm.providerEnvironment.toUpperCase()}}</strong><br>
                  <span v-if="itm.userGroupDefault">{{itm.userGroupDefault.name}}</span>
                </b-card-text>
                <b-row>
                  <b-col sm="12" lg="4" class="p-1">
                    <b-button class="form-control" href="#" variant="danger" size="sm" @click="removeApplication(idx)">Remover</b-button>
                  </b-col>
                  <b-col sm="12" lg="4" class="p-1">
                    <b-button class="form-control" href="#" variant="info" size="sm" @click="toMonitor(itm.clientId)">Monitor</b-button>
                  </b-col>
                  <b-col sm="12" lg="4" class="p-1">
                    <b-button class="form-control" href="#" variant="success" size="sm" @click="toApiKey(itm)">Chave API</b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-modal
            id="modal-add-app"
            ref="modal"
            title="Adicionar aplicação"
            @show="resetApplicationModal"
            @hidden="resetApplicationModal"
            @ok="handleOkApplication"
          >
            <form ref="form" @submit.stop.prevent="handleSubmitApplication">
              <b-form-group label="Id do Cliente" label-for="app-client-id">
                <b-form-input id="app-client-id" v-model="application.clientId"></b-form-input>
              </b-form-group>
              <b-form-group label="Ambiente" label-for="app-provider-environment">
                <b-form-select v-model="application.providerEnvironment" id="app-provider-environment">
                  <option value="vault">Vault</option>
                  <option value="bird">Bird</option>
                </b-form-select>
              </b-form-group>
              <b-form-group v-if="corporation.id" label="Grupo de Usuários Padrão" label-for="app-group-default">
                <b-form-select v-model="application.userGroupDefault" id="app-group-default">
                  <option :value="null"></option>
                  <option v-for="userGroup in userGroups" v-bind:key="userGroup.id" :value="userGroup">{{userGroup.name}}</option>
                </b-form-select>
              </b-form-group>
            </form>
          </b-modal>
        </b-form-group>
        
        <b-form-group
          label="Grupo"
          label-for="app-group-default"
          >
          <b-form-select v-model="corporation.billingCorporationGroup" id="app-group-default">
            <option :value="null"></option>
            <option v-for="corporationGroup in corporationGroups" v-bind:key="corporationGroup.id" :value="corporationGroup.id">{{corporationGroup.name}}</option>
          </b-form-select>
        </b-form-group>
        
        <b-form-group
          label="Tags"
          label-for="tags"
          >
          <vue-tags-input class="form-group"
            v-model="tag"
            :tags="tags"
            placeholder="Add Tag"
            @tags-changed="newTags => tags = newTags"
          />
        </b-form-group>

        <b-form-group
          label="Licença"
          label-for="license"
          >
          <b-form-select id="license"
            v-model="corporation.licenseType"
            :plain="true"
            :options="selectLicense">
          </b-form-select>
        </b-form-group>
        
        <b-form-group
          label=""
          label-for="retailConsume">
          <b-form-checkbox
            id="retailConsume"
            v-model="corporation.retailConsume"
            name="retailConsume"
          >
            Consumir créditos do varejo
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          label="Tipo de gerenciamento"
          label-for="managementUserType"
          >
          <b-form-select id="managementUserType"
            v-model="corporation.managementUserType"
            :plain="true"
            :options="selectManagementUserType">
          </b-form-select>
        </b-form-group>
        
        <!-- <b-form-group
          label="Período de cobrança"
          label-for="billingPeriod"
          >
          <b-form-select id="billingPeriod"
            v-model="corporation.billingPeriod"
            :plain="true"
            :options="selectBillingPeriod">
          </b-form-select>
        </b-form-group> -->

        <b-form-group label="Permissões" label-for="list-role">
          <div  class="input-group input-group-sm">
            <b-form-select v-model="role" :options="roles" :plain="true" id="list-role">
            </b-form-select>
            <span class="input-group-append">
              <button id="btn-add" class="btn btn-secondary" type="button" @click="addRole" @click.stop.prevent><i class="fa fa-plus"></i></button>
            </span>
          </div>
        </b-form-group>
        <b-form-group>
          <div class="alert alert-secondary" role="alert" v-if="!corporation.roles || corporation.roles.length == 0">
            Nenhuma permissão adicionada
          </div>
          <b-card-group deck>
            <b-col class="p-0" sm="12" lg="3" v-for="(itm, idx) in (corporation.roles || [])" v-bind:key="idx">
              <b-card class="text-center ">
                <b-card-text>
                  <b>{{ roleText(itm) }}</b>
                </b-card-text>
                <b-row>
                  <b-col>
                    <b-button  class="form-control" href="#" variant="danger" size="sm" @click="removeRole(idx)">Remover</b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-card-group>
        </b-form-group>

        <b-form-group
          label="Limite de usuários"
          label-for="maxUsers"
          >
          <b-input-group>
            <template #append v-if="corporation.isUsersFull">
              <b-input-group-text class="bg-warning" title="Quantidade máxima de usuários atingida"><strong>Cheio</strong></b-input-group-text>
            </template>
            <b-form-input v-model="corporation.maxUsers" id="maxUsers" type="number"></b-form-input>
          </b-input-group>
        </b-form-group>
        
        <!-- <b-form-group
          label="Dia de fechamento"
          label-for="closingDay"
          >
          <b-form-input v-model="corporation.closingDay" id="closingDay" type="number"></b-form-input>
        </b-form-group> -->

        <b-form-group
          label="Dias após ativação para disponibilizar o assento"
          label-for="daysAvailableSeat"
          >
          <b-form-input v-model="corporation.daysAvailableSeat" id="daysAvailableSeat" type="number"></b-form-input>
        </b-form-group>

        <b-form-group
          description="Valor padrão do prazo para a expiração do usuário"
          label="Prazo expiração"
          label-for="userExpireTimeDefault"
          >
          <b-form-row>
            <b-col>
              <b-form-input v-model="expireTimeDefaultValue" id="userExpireTimeDefault" type="number" max="365" min="1"></b-form-input>
            </b-col>
            <b-col>
              <b-form-select id="expireTimeType"
                v-model="expireTimeDefaultType"
                :plain="true"
                :options="selectExpireType">
              </b-form-select>
            </b-col>
          </b-form-row>
        </b-form-group>

        <b-card :header="'Licença do CESS'">

          <b-form-group
          label="Status"
          label-for="cessStatus"
          >
            <b-form-select id="cessStatus"
              v-model="cess.status"
              :plain="true"
              :options="cessStatus">
            </b-form-select>
          </b-form-group>

          <b-form-group
          label="Quantidade máxima de instâncias"
          label-for="cessInstances"
          >
            <b-form-input id="cessInstances"
              v-model="cess.instancesLimit"
              type="number"
              min="0"
              step="1"
              :placeholder="'Digite o limite de instâncias'">
            </b-form-input>
          </b-form-group>

          <b-form-group
          label="Tipo de licença"
          label-for="cessLicenseType"
          >
            <b-form-select id="cessLicenseType"
              v-model="cess.licenseType"
              :plain="true"
              :options="cessLicenseTypes">
            </b-form-select>
          </b-form-group>

          <b-form-group
          label="Plugin de assinatura desktop"
          label-for="desktopPluginStatus"
          >
            <b-form-select id="desktopPluginStatus"
              v-model="cess.desktopPlugin.status"
              :plain="true"
              :options="desktopPluginStatus">
            </b-form-select>
          </b-form-group>

          <b-form-group
            label=""
            label-for="hubAuthentication">
            <b-form-checkbox
              id="hubAuthentication"
              v-model="cess.hubAuthentication"
              name="hubAuthentication"
            >
              HUB de autenticação
            </b-form-checkbox>
          </b-form-group>

          <b-form-group
            label=""
            label-for="virtualPrinter">
            <b-form-checkbox
              id="virtualPrinter"
              v-model="cess.virtualPrinter"
              name="virtualPrinter"
            >
              Impressora Virtual
            </b-form-checkbox>
          </b-form-group>

        </b-card>

        <b-form-group
          label=""
          label-for="autoRenovationDefault">
          <b-form-checkbox
            id="autoRenovationDefault"
            v-model="corporation.autoRenovationDefault"
            name="autoRenovationDefault"
          >
            Renovação automática
          </b-form-checkbox>
        </b-form-group>

        <b-form-group v-if="corporation.createDate"  :description="'Criado em: ' + formatDate(corporation.createDate.date)" label-for="createDate">
        </b-form-group>
        
        <div slot="footer">
          <b-row>
            <b-col sm="12" lg="2">
              <b-button class="form-control" type="submit" variant="primary" @click="save"><i class="fa fa-dot-circle-o"></i> Gravar</b-button>&nbsp;
            </b-col>
            <b-col sm="12" lg="2">
              <b-button class="form-control" type="button" variant="secondary" @click="goBack"><i class="fa fa-arrow-left"></i> Voltar</b-button>&nbsp;
            </b-col>
            <template  v-if="corporation.id && isAllowed('super_admin')">
            <b-col sm="12" lg="2">
              <b-button class="form-control" type="button" variant="danger" @click="deleteCorporation"><i class="fa fa-remove"></i> Excluir</b-button>&nbsp;
            </b-col>
            <b-col sm="12" lg="2">
              <b-button class="form-control" type="button" variant="warning" @click="cleanRenovations"><i class="fa fa-recycle"></i> Renovações</b-button>
            </b-col>
            </template>
          </b-row>
        </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, formatDate, isAllowed } from '@/shared/utils';
import _ from 'underscore';
import { mapActions } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  name: 'Corporation',
  components: {
    Loading,
    VueTagsInput
  },
  props: {
    caption: {
      type: String,
      default: 'Corporação'
    },
  },
  data: () => {
    return {
      selectLicense: [
        { value: 'withoutReplacement', text: 'Sem substituição' },
        { value: 'activeUser', text: 'Usuário ativo' }, 
        { value: 'bySeat', text: 'Por assento' }
      ],
      selectManagementUserType: [
        { value: 'permissive', text: 'Permissivo' },
        { value: 'restrictive', text: 'Restritivo' }
      ],
      selectExpireType: [
        { value: 'day', text: 'Dia' },
        { value: 'month', text: 'Mês' },
        { value: 'year', text: 'Ano' }
      ],
      selectBillingPeriod: [
        { value: 'monthly', text: 'Mensal' },
        { value: 'semiannually', text: 'Semestral' }, 
        { value: 'yearly', text: 'Anual' }
      ],
      corporationGroups: [],
      corporation: {
        clientIdsByProvider: {},
        adminUsers: [],
        roles: [],
        tags: []
      },
      application: {
        id: null,
        clientId: '',
        providerEnvironment: ''
      },
      adminUser: '',
      applications: [],
      userGroups: [],
      roles: [
        {text: 'Autenticação por SMS', value: 'sms'},
        {text: 'Carimbo do Tempo', value: 'act'},
        {text: 'Notificação no app', value: 'generic_push'},
        {text: 'Autenticação por notificação', value: 'auth_push'},
        {text: 'Solicitação de logs do app', value: 'app_logs'},
        {text: 'Notificação de renovação de certificado', value: 'certificate_renovation_push'},
        {text: 'Websocket BirdID', value: 'websocket_birdid'},
        {text: 'Assinatura por notificação', value: 'sign_push'},
        {text: 'Chave de API por notificação', value: 'api_key_push'},
      ],
      role: null,
      loadCount: 0,
      expireTimeDefault: {
        value: null, // Valor inteiro da expressão
        type: null, // Tipo do período (ano, mês, dia)
        final: null // Combinação do valor e o tipo ex: +30 day
      },
      id: '',
      cessStatus: [
        {value: 0, text: 'Desativado'},
        {value: 1, text: 'Ativado'},
      ],
      cess: {
        status: '',
        instancesLimit: '',
        licenseType: '',
        desktopPlugin: {status: ''},
        hubAuthentication: false,
        virtualPrinter: false
      },
      cessLicenseTypes: [],
      desktopPluginStatus: [
        {value: 0, text: 'Desativado'},
        {value: 1, text: 'Ativado'},
      ],
      tag: '',
      tags: []
    }
  },
  async mounted() {
    await this.getLicenseTypes();
    this.id = this.$route.params.id;
    if (this.id) {
      await this.getUserGroups();
    }
    await this.getCorporationGroups();
    await this.getCorporation(this.$route.params.id);
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    },
    expireTimeDefaultValue: {
      get: function () {
        let matches = this.getSplitedUserExpireTime();
        if (matches == null) {
          return null;
        }
        return matches[1];
      },
      set: function (val) {
        this.expireTimeDefault.value = val;
      }
    },
    expireTimeDefaultType: {
      get: function () {
        let matches = this.getSplitedUserExpireTime();
        if (matches == null) {
          return null;
        }
        return matches[2];
      },
      set: function (val) {
        this.expireTimeDefault.type = val;
      }
    }
  },
  methods: {
    toMonitor(id) {
      this.$router.push('/corporations/monitor/'+ id);
    },
    toApiKey(application) {
      this.$router.push(`/corporations/api-key/${application.id}?corporation=${this.corporation.name}&client=${application.clientId}&env=${application.providerEnvironment}`);
    },
    isAllowed(role) {
      return isAllowed(role);
    },
    ...mapActions(['addCorporation', 'removeCorporation']),
    formatDate(date) {
      return formatDate(date, "dd/MM/yyyy hh:mm");
    },
    getSplitedUserExpireTime() {
      if (!this.corporation || !this.corporation.userExpireTimeDefault) {
        return null;
      }
      return /\+(\d+)\s([a-z]+)/.exec(this.corporation.userExpireTimeDefault);
    },
    resetApplicationModal() {
      this.application = {
        id: null,
        clientId: '',
        providerEnvironment: ''
      }
    },
    resetAdminModal() {
      this.adminUser = '';
    },
    handleOkApplication(e) {
      e.preventDefault();
      this.handleSubmitApplication();
    },
    handleSubmitApplication() {
      this.applications.push(this.application);
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
    },
    handleOkAdmin(e) {
      e.preventDefault();
      this.handleSubmitAdmin();
    },
    handleSubmitAdmin() {
      this.corporation.adminUsers.push(this.adminUser);
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
    },
    addRole() {
      if (this.role) {
        let alreadyExists = this.corporation.roles.includes(this.role);
        if (!alreadyExists) {
          this.corporation.roles.push(this.role);
        }
        this.role = null;
      }
    },
    removeRole(idx) {
      this.corporation.roles.splice(idx, 1);
    },
    roleText(roleVal) {
      return _.findWhere(this.roles, {value: roleVal}).text;
    },
    async getCorporation(id) {
      if (!id) {
        return;
      }
      this.loadCount++;
      try {
        let response = await axios.get(`${env.urlBillingApi}/corporation/${id}`);

        if (response.data.cess != undefined) {
          this.cess = response.data.cess;
        }

        this.corporation = response.data;
        this.corporation.autoRenovationDefault = this.corporation.autoRenovationDefault ? true : false;
        this.tags = (this.corporation.tags || []).map(itm => { return {text: itm, tiClass: ["ti-valid"]} });
        this.corporation.roles || (this.corporation.roles = []);
        _.mapObject(this.corporation.clientIdsByProvider, (clients, provider) => {
          clients.forEach((client) => {
            this.applications.push({
              id: client.applicationId,
              providerEnvironment: provider, 
              clientId: client.clientId,
              userGroupDefault: client.userGroupDefault
            });
          });
        });
        if (this.corporation.billingCorporationGroup) {
          this.corporation.billingCorporationGroup = this.corporation.billingCorporationGroup.id;
        }

      } catch (error) {
        requestError(error);
      } finally {
        this.loadCount--;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    removeApplication(idx) {
      this.applications.splice(idx, 1);
    },
    removeAdmin(idx) {
      this.corporation.adminUsers.splice(idx, 1);
    },
    save() {
      var url = `${env.urlBillingApi}/corporation`;
      if (this.corporation.id) {
        url += `/${this.corporation.id}`;
      }
      var _this = this;
      this.corporation.clientIdsByProvider = {};
      this.applications.forEach(app => {
        _this.corporation.clientIdsByProvider[app.providerEnvironment] || (_this.corporation.clientIdsByProvider[app.providerEnvironment] = []);
        _this.corporation.clientIdsByProvider[app.providerEnvironment].push({
          id: app.applicationId,
          clientId: app.clientId,
          userGroupDefault: app.userGroupDefault && app.userGroupDefault.id
        });
      });
      if (this.expireTimeDefault.type && this.expireTimeDefault.value) {
        this.corporation.userExpireTimeDefault = `+${this.expireTimeDefault.value} ${this.expireTimeDefault.type}`;
      }
      this.loadCount++;
      this.corporation.cess = this.cess;
      this.corporation.tags = this.tags.map(itm => itm.text);

      let request = this.corporation.id ? axios.put(url, this.corporation) : axios.post(url, this.corporation);
      request.then(function(response) {
          var corp = response.data;
          if (!_this.corporation.id) {
            _this.addCorporation(corp);
          }
          _this.$bvModal.msgBoxOk('Corporação gravada com sucesso!')
          .then(value => {
            _this.$router.replace({path: '/corporations'});
          })
          .catch(console.error);
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    deleteCorporation() {
      var _this = this;
      var id = this.corporation.id;
      if (!id) return;
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir o registro?', {
        okVariant: 'danger',
        okTitle: 'Sim',
        cancelTitle: 'Não',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          _this.loadCount++;
          axios
            .delete(`${env.urlBillingApi}/corporation/${id}`)
            .then(function(response) {
            _this.removeCorporation(id);
            _this.$bvModal.msgBoxOk('Corporação excluída com sucesso!')
              .then(value => {
                _this.$router.replace({path: '/corporations'});
              })
              .catch(console.error);
          }).catch(function(error) {
            requestError(error);
          })
          .finally(() => {
            _this.loadCount--;
          });
        }
      }).catch(alert);
    },
    cleanRenovations() {
      var _this = this;
      var id = this.corporation.id;
      if (!id) return;
      this.$bvModal.msgBoxConfirm('Essa ação remove todos os eventos de ativação e renovação dos usuários dessa corporação. Esses eventos serão recriados no próximo ciclo de verificação. Deseja realmente continuar?', {
        okVariant: 'danger',
        okTitle: 'Sim',
        cancelTitle: 'Não',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          _this.loadCount++;
          axios
            .patch(`${env.urlBillingApi}/corporation/${id}`)
            .then(function(response) {
            _this.$bvModal.msgBoxOk('Ativações e renovações excluídas com sucesso!')
              .catch(console.error);
          }).catch(function(error) {
            requestError(error);
          })
          .finally(() => {
            _this.loadCount--;
          });
        }
      }).catch(alert);
    },
    async getLicenseTypes() {
      try {
        let response = await axios.get(`${env.urlBillingApi}/cess-license`);
        var licenseTypesArr = response.data.data;
        this.cessLicenseTypes = licenseTypesArr.map(function (licenseType){
          return {
            value : licenseType.id,
            text : licenseType.name
          }
        });
      } catch(error) {
        requestError(error);
      }
    },
    async getUserGroups() {
      this.loadCount++;
      try {
        let response = await axios.get(`${env.urlBillingApi}/user-group`);
        this.userGroups = response.data._embedded.user_group;
      } catch(error) {
        requestError(error);
      } finally {
        this.loadCount--;
      }
    },
    async getCorporationGroups() {
      this.loadCount++;
      try {
        let response = await axios.get(`${env.urlBillingApi}/corporation-group`);
        this.corporationGroups = response.data._embedded.corporation_group;
      } catch(error) {
        requestError(error);
      } finally {
        this.loadCount--;
      }
    },
  }
}
</script>

<style scoped>
.clientID {
  font-size: 16px;
}
@media (min-width: 576px) {
  /* .card-body >>> .card-list {
    max-width: 200px;
  } */
}
</style>